/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import noop from "lodash/fp/noop";
import { Grid, Tooltip } from "@material-ui/core";
import { Link } from "react-router-dom";

import { SecondaryColorLabel } from "../../sharedStyles";
import {
  notifCounterCss,
  innerContainerCss,
  labelCss,
  getOuterContainerCss,
  ToggleStarFavourite,
} from "./styles";
import { LinkTo, TemplateId } from "../../../../../../globalTypes";
import { OverviewTemplateRouteState } from "../../../../../../utils/internalLinksParsing";

const TemplateCardKpiVariant: FC<Props> = ({
  label,
  linkTo,
  onClick = noop,
  isFavourite,
  toggleFavourite,
  backgroundColor,
  notificationCount,
}) => (
  <Grid item xs={4} md="auto">
    <Tooltip title={label}>
      <div css={getOuterContainerCss(backgroundColor)}>
        <Link
          onClick={onClick}
          to={linkTo as LinkTo<unknown>}
          css={innerContainerCss}
        >
          <span css={notifCounterCss}>{notificationCount}</span>
          <SecondaryColorLabel css={labelCss}>{label}</SecondaryColorLabel>
        </Link>

        <ToggleStarFavourite active={isFavourite} onClick={toggleFavourite} />
      </div>
    </Tooltip>
  </Grid>
);

type Props = {
  label: string;
  linkTo?: LinkTo<OverviewTemplateRouteState>;
  onClick?: () => void;
  isFavourite: boolean;
  toggleFavourite: () => void;
  notificationCount: number;
  backgroundColor: string;
};

export type TemplateCardKpiViewProps = Props;
export default TemplateCardKpiVariant;
